import { render, staticRenderFns } from "./ApplicantDetails.vue?vue&type=template&id=782036dc&"
import script from "./ApplicantDetails.vue?vue&type=script&lang=js&"
export * from "./ApplicantDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ApplicantDetails.vue"
export default component.exports